// ======================================================================
// File Name       : ContentDrillSkinDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { getItemBoxName } from '../../utils/index';
import { getEnterprisePath } from '../../utils/EnterPriseUtils';
import { MODE } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';

const ContentDrillSkinDetail = ({ skinSetInfo }) =>
  (<Col sm={12}>
    <Form className='form-horizontal'>
      <Form.Group className="form-info" controlId="formHorizontalSkinSetSecernId">
        <Col sm={3} className="form-label">
          スキン識別ID
        </Col>
        <Col sm={7} className="padding-top-bottom-10">
          {skinSetInfo.skinSetSecernId}
        </Col>
      </Form.Group>

      <Form.Group className="form-info" controlId="formHorizontalSkinSetName">
        <Col sm={3} className="form-label">
          スキン名
        </Col>
        <Col sm={7} className="padding-top-bottom-10">
          {skinSetInfo.skinSetName}
        </Col>
      </Form.Group>

      <Form.Group className="form-info" controlId="formHorizontalSkinSetFileName">
        <Col sm={3} className="form-label">
          ファイル名
        </Col>
        <Col sm={7} className="padding-top-bottom-10">
          {skinSetInfo.skinSetZipFileName}
        </Col>
      </Form.Group>
    </Form>
  </Col>);
export default ContentDrillSkinDetail;
